import { useQueries } from "@tanstack/react-query";

import { changeRequestQueryOptions } from "~/change-request/data-source/api/change-request-query-options";

export function changeRequestMetadataKey(systemId: string, changeRequestId: string) {
  return JSON.stringify([systemId, changeRequestId]);
}

export function useChangeRequestMetadata(pairs: { systemId: string; changeRequestId: string }[]) {
  const unique = [
    ...new Map(
      pairs
        .filter((pair) => pair.systemId && pair.changeRequestId)
        .map((pair) => [changeRequestMetadataKey(pair.systemId, pair.changeRequestId), pair]),
    ).values(),
  ];
  return useQueries({
    queries: unique.map((pair) => changeRequestQueryOptions.byId(pair.systemId, pair.changeRequestId)),
    combine: (results) =>
      Object.fromEntries(
        results.map((result, index) => [
          changeRequestMetadataKey(unique[index].systemId, unique[index].changeRequestId),
          {
            data: result.data ? { title: result.data.title, createdById: result.data.createdById } : undefined,
            error: result.error,
            isLoading: result.isLoading,
            isError: result.isError,
          },
        ]),
      ),
  });
}
